'use client';

import { useState, type FormEvent } from 'react';
import Link from 'next/link';
import { Container, Section } from '@/components/primitives';
import { Header } from '@/components/header';
import { Footer } from '@/components/footer';

export default function DeleteAccountPage() {
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');
  const [confirmed, setConfirmed] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email || !confirmed) return;
    // TODO: integrar com fce-books-api POST /me/delete-request
    setSent(true);
  };

  return (
    <div className="page-fade">
      <Header />
      <Section pad="lg">
        <Container>
          <div className="eyebrow" style={{ marginBottom: 14 }}>Cuenta</div>
          <h1 className="serif" style={{ margin: 0, fontSize: 48, lineHeight: 1.05, letterSpacing: '-0.02em', fontWeight: 600 }}>
            Eliminar mi cuenta
          </h1>
          <p style={{ marginTop: 16, color: 'var(--ink-soft)', fontSize: 16, maxWidth: 620 }}>
            La eliminación es definitiva. Perderás el acceso a tus préstamos, historial y favoritos. Procesamos las solicitudes en un plazo de hasta 30 días, conforme a la LFPDPPP.
          </p>
        </Container>
      </Section>

      <Section pad="md">
        <Container>
          {sent ? (
            <div style={{ maxWidth: 560, padding: '22px 24px', background: 'var(--paper-2)', borderRadius: 2, fontSize: 14 }}>
              Recibimos tu solicitud para <strong>{email}</strong>. Te confirmaremos por correo en cuanto se complete el proceso.
              <div style={{ marginTop: 14 }}>
                <Link href="/" className="under" style={{ color: 'var(--ink)' }}>← Volver al inicio</Link>
              </div>
            </div>
          ) : (
            <form onSubmit={onSubmit} style={{ maxWidth: 560, display: 'flex', flexDirection: 'column', gap: 16 }}>
              <label>
                <div className="eyebrow" style={{ marginBottom: 6 }}>Correo registrado</div>
                <input className="input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </label>
              <label>
                <div className="eyebrow" style={{ marginBottom: 6 }}>Motivo (opcional)</div>
                <textarea
                  className="input"
                  rows={4}
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Si quieres, cuéntanos por qué te vas."
                />
              </label>
              <label style={{ display: 'flex', gap: 10, fontSize: 13, color: 'var(--ink-soft)' }}>
                <input type="checkbox" className="check" checked={confirmed} onChange={(e) => setConfirmed(e.target.checked)} />
                <span>
                  Entiendo que la eliminación es irreversible y acepto perder todo el contenido asociado a mi cuenta.
                </span>
              </label>
              <div style={{ marginTop: 8 }}>
                <button type="submit" className="btn btn-primary" disabled={!confirmed}>
                  Solicitar eliminación
                </button>
              </div>
            </form>
          )}
        </Container>
      </Section>
      <Footer />
    </div>
  );
}
